import {gql} from '@apollo/client';

export const QUERY_CALC = gql`
query calc($positions: [CalcPosition]!, $promo: String, $delivery: String) {
    calc(positions: $positions, promo: $promo, delivery: $delivery) {
        calc_market_sum
        calc_sum
        calc_discount
        calc_delivery
        calc_total
        promo_accepted
    }
}`